<template>
  <div :class="[$style.base, { [$style.isSelected]: isSelected }]">
    <div :class="$style.inner" @click="isSelected = !isSelected">
      <div
        :class="$style.checkbox"
        :style="
          isSelected
            ? {
                'background-color': widgetSettings.color,
                'border-color': widgetSettings.color
              }
            : {
                'border-color': widgetSettings.color
              }
        "
        v-test="'confirm-checkbox'"
      >
        <IconCheck :isSmall="true" v-show="isSelected" />
      </div>
      <div :class="$style.label">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconCheck from '@/components/IconCheck.vue';
import widgetSettings from '@/widget-settings';
import { computed } from 'vue';

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const isSelected = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
});
</script>

<style lang="scss" module>
.inner {
  display: inline-flex;
  align-items: center;
}

.checkbox {
  position: relative;
  width: 17px;
  height: 17px;
  border-radius: 2px;
  border: 1px solid;
  flex-shrink: 0;

  svg {
    position: absolute;
    left: -1px;
    top: 2px;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}

.label {
  cursor: default;
  padding-left: 8px;
  font-size: 14px;
}
</style>
